import 'qtip2/dist/basic/jquery.qtip';
import 'Vendors/jquery.cookie';

import { GetBreakpointWidth } from 'Utils/globals-bp';

var defaultMinRoomsShown = 2;
var defaultMinRoomBoardsShown = 2;


export function ShowMoreRoomTypesTitle(availableRoomTypes, minRoomsShown) {
    var text = AppData.Translations["show-more-rooms"];
    var count = "";

    if (!minRoomsShown)
        minRoomsShown = defaultMinRoomsShown;

    if (availableRoomTypes && availableRoomTypes.length > minRoomsShown) {
        count = availableRoomTypes.length - minRoomsShown;
    }

    return String.format(text, count);
};

export function ShowLessRoomTypes(index, clsHolder, minRoomsShown) {
    var roomsHolder = '.rooms';

    if (clsHolder != "")
        roomsHolder = clsHolder + " " + roomsHolder;

    if (!minRoomsShown)
        minRoomsShown = defaultMinRoomsShown;

    $(roomsHolder).each(function (i, e) {
        if (index == i || index < 0) {
            $(e).find('.room').each(function (j, r) {
                if (j >= minRoomsShown)
                    $(r).hide();
                else
                    $(r).show();
            });

            $(e).parents('.room-container').find('.show-more-rooms').show().css('display', 'inline-block');
            $(e).parents('.room-container').find('.show-less-rooms').hide();

            if ($(e).find('.room').length <= minRoomsShown) {
                $(e).parents('.room-container').find('.show-more-rooms').hide();
            }
        }
    });
};

export function ShowMoreRoomTypes(index, clsHolder, minRoomsShown) {
    var roomsHolder = '.rooms';

    if (clsHolder != "")
        roomsHolder = clsHolder + " " + roomsHolder;

    $(roomsHolder).each(function (i, e) {
        if (index == i) {
            $(e).find('.room').each(function (j, r) {
                $(r).show();
            });

            $(e).parents('.room-container').find('.show-more-rooms').hide();
            $(e).parents('.room-container').find('.show-less-rooms').show().css('display', 'inline-block');

            if ($(e).find('.room').length <= minRoomsShown) {
                $(e).parents('.room-container').find('.show-less-rooms').hide();
            }
        }
    });
};

export function ShowLessRoomTypeBoards(indexRoom, indexRoomType, clsHolder, minRoomBoardsShown) {
    var roomsHolder = '.rooms';

    if (clsHolder != "")
        roomsHolder = clsHolder + " " + roomsHolder;

    if (!minRoomBoardsShown)
        minRoomBoardsShown = defaultMinRoomBoardsShown;

    $(roomsHolder).each(function (i, e) {
        if (indexRoom == i || indexRoom < 0) {
            $(e).find('.room').each(function (j, r) {
                if (indexRoomType == j || indexRoomType < 0) {
                    let $r = $(r);
                    $r.find(".room-board").each(function (indx, b) {
                        if (indx >= minRoomBoardsShown)
                            $(b).hide();
                        else
                            $(b).show();
                    });

                    $r.find('.show-less-room-boards').hide();

                    if ($r.find('.room-board').length <= minRoomBoardsShown) {
                        $r.find('.show-more-room-boards').hide();
                        $r.find('.btn-more-room-boards-container').hide();
                    } else {
                        $r.find('.show-more-room-boards').show().css('display', 'inline-block');
                        $r.find('.btn-more-room-boards-container').show();
                    }
                }
            });
        }
    });
};

export function ShowMoreRoomTypeBoards(indexRoom, indexRoomType, clsHolder, minRoomBoardsShown) {
    var roomsHolder = '.rooms';

    if (clsHolder != "")
        roomsHolder = clsHolder + " " + roomsHolder;

    $(roomsHolder).each(function (i, e) {
        if (indexRoom == i) {

            $(e).find('.room').each(function (j, r) {
                if (indexRoomType == j || indexRoomType < 0) {
                    let $r = $(r);
                    $r.find(".room-board").each(function (indx, b) {
                        $(b).show();
                    });

                    $r.find('.show-more-room-boards').hide();

                    if ($r.find('.room-board').length <= minRoomBoardsShown) {
                        $r.find('.show-less-room-boards').hide();
                        $r.find('.btn-more-room-boards-container').hide();
                    } else {
                        $r.find('.show-less-room-boards').show().css('display', 'inline-block');
                        $r.find('.btn-more-room-boards-container').show();
                    }
                }

            });
        }
    });
};

export function IsCookieEnabled() {
    var cookieEnabled = (navigator.cookieEnabled) ? true : false;

    if (typeof navigator.cookieEnabled == "undefined" && !cookieEnabled) {
        //document.cookie = "testcookie";
        //cookieEnabled = (document.cookie.indexOf("testcookie") != -1) ? true : false;

        var name = "testcookie";
        var options = { expires: 365, path: '/' };
        $.cookie(name, 1, options);
        var value = $.cookie(name);
        cookieEnabled = value == 1;
    }
    return (cookieEnabled);
};


function ArrayElementId(arrayName, itemIndex, fieldName) {
    var prefix = arrayName + "[" + itemIndex + "]";
    if (!fieldName)
        return prefix;
    return prefix + "." + fieldName;
};
function Array2ElementId(arrayName, itemIndex, subArrayName, subItemIndex, fieldName) {
    var prefix = arrayName + "[" + itemIndex + "]." + subArrayName + "[" + subItemIndex + "]";
    if (!fieldName)
        return prefix;
    return prefix + "." + fieldName;
};

export function RoomsPassengersElemId(roomIndex, passengerIndex, fieldName) {
    // "rooms[" + roomIndex + "].passengers[" + passengerIndex + "]." + fieldName
    return Array2ElementId("rooms", roomIndex, "passengers", passengerIndex, fieldName);
};

export function RoomsElemId(roomIndex, fieldName) {
    // "Rooms[" + roomIndex + "]." + fieldName
    return ArrayElementId("Rooms", roomIndex, fieldName);
};

export function RoomsChildrenElemId(roomIndex, childIndex, fieldName) {
    // "Rooms[" + roomIndex + "].Children[" + childIndex + "]." + fieldName
    return Array2ElementId("Rooms", roomIndex, "Children", childIndex, fieldName);
};

export function SelectedRoomsElemId(roomIndex, fieldName) {
    // "SelectedRooms[" + roomIndex + "]." + fieldName
    return ArrayElementId("SelectedRooms", roomIndex, fieldName);
};

export function SelectedRoomFeesElemId(roomIndex, feeIndex, fieldName) {
    // "Rooms[" + roomIndex + "].SelectedFees[" + feeIndex + "]." + fieldName
    return Array2ElementId("Rooms", roomIndex, "SelectedFees", feeIndex, fieldName);
};

export function HotelExtraBookingElemId(hotelExtraIndex, fieldName) {
    var prefix = "HotelExtras[" + hotelExtraIndex + "]";
    if (!fieldName)
        return prefix;
    return prefix + "." + fieldName;
};

export function HotelExtraElemId(prefix, hotelExtraIndex) {
    return prefix + "[" + hotelExtraIndex + "]";
};

export function CarRentalExtraElemId(itemIndex, fieldName) {
    return ArrayElementId('CarRentalExtras', itemIndex, fieldName);
};

export function SelectedCarRentalExtraElemId(itemIndex, fieldName) {
    return ArrayElementId('SelectedCarRentalExtras', itemIndex, fieldName);
};

export function CarRentalFeeElemId(itemIndex, fieldName) {
    return ArrayElementId('CarRentalFees', itemIndex, fieldName);
};


export function GetHotelSummaryRoomTooltipOptions(element) {
    var options = {
        content: {
            text: $(element).next('div') // Use the "div" element next to this for the content
        },
        style: {
            classes: 'qtip-room-cpi-info qtip-to-front qtip-brand-style',
            def: false,
        },
        position: {
            target: $(element).find(".room-board-info"),

            my: 'bottom center',
            at: 'top right',
            tooltip: 'topMiddle',
            adjust: {
                y: 0
            }
        }
    };
    return options;
};

export function SetHotelRoomsTooltips() {
    $('.show-room-name-info-hover').each(function () { // Notice the .each() loop, discussed below
        $(this).qtip({
            content: {
                text: $(this).next('div') // Use the "div" element next to this for the content
            },
            style: {
                classes: 'qtip-to-front qtip-brand-style',
                def: false
            },
            position: {
                target: $(this),
                //my: 'top right',
                //at: 'bottom right',
                //tooltip: 'bottomRight',
                my: 'top left',
                at: 'bottom left',
                tooltip: 'bottomLeft',
                //my: 'left center',
                //at: 'right center',
                //tooltip: 'topMiddle',
                adjust: {
                    x: -10
                }
            }
        });
    });

    $('.room-board').find("div.show-room-cpi-info-hover").each(function () { // Notice the .each() loop, discussed below
        let $hoverinfo = $(this).next('div'); // Use the "div" element next to this for the content
        if ($hoverinfo.length < 1) {
            // nofound container with info
            return; // 'continue' loop
        }
        if (!$hoverinfo.hasClass('room-cpi-hoverinfo')) {
            // un-expected container
            return; // 'continue' loop
        }

        $(this).qtip({
            content: {
                text: $hoverinfo
            },
            style: {
                classes: 'qtip-room-cpi-info qtip-to-front qtip-brand-style p-0',
                def: false,
            },
            position: {
                target: $(this),

                my: 'bottom center',
                at: 'top center',
                tooltip: 'topMiddle',
                adjust: {
                    y: 0
                }
            }
        });
    });


    $('.btn-continue-booking').on("click", function (e) {
        ScrollToTarget(".mytrip-summary");
        //ScrollToTarget(".mytrip-summary .btn-checkout");
    });
};

export function SetHotelArrivalTooltips() {
    var flgInfo = false;
    if (myTripSearchViewModel != null) {
        flgInfo = myTripSearchViewModel.IsAnotherHotelArrivalDate();
    }

    if (flgInfo) {
        $(".hotelsection .hotel-arrival").addClass("show-hotel-arrival-info-hover");
    } else {
        $(".hotelsection .hotel-arrival").removeClass("show-hotel-arrival-info-hover");
    }


    $('.show-hotel-arrival-info-hover').each(function () { // Notice the .each() loop, discussed below
        $(this).qtip({
            content: {
                text: $(this).next('div') // Use the "div" element next to this for the content
            },
            style: {
                classes: 'qtip-to-front qtip-brand-style',
                def: false
            },
            position: {
                target: $(this),
                my: 'top left',
                at: 'bottom left',
                tooltip: 'bottomLeft',
                adjust: {
                    x: -10
                }
            }
        });
    });
};

export function SetRoomsPassengersTooltips() {
    $('.show-passenger-type-info-hover').each(function () { // Notice the .each() loop, discussed below
        $(this).qtip({
            content: {
                text: $(this).next('div') // Use the "div" element next to this for the content
            },
            style: {
                classes: 'qtip-to-front qtip-brand-style',
                def: false
            },
            position: {
                target: $(this),
                //my: 'top right',
                //at: 'bottom right',
                //tooltip: 'bottomRight',
                my: 'top left',
                at: 'bottom left',
                tooltip: 'bottomLeft',
                //my: 'left center',
                //at: 'right center',
                //tooltip: 'topMiddle',
                adjust: {
                    x: -10
                }
            }
        });
    });
};

// 2022-06-03 unused function
// export function matchHeightsAirports() {
//     $('.departure-airport').matchHeight({
//         byRow: true,
//         //byRow: false,
//         property: 'height',
//         //property: 'min-height',
//         //target: null,
//         //remove: false
//     });
// };

// 2022-06-03 unused function
// export function matchHeightsAirlines() {
//     $('.airline').matchHeight({
//         //byRow: true,
//         byRow: false,
//         property: 'height',
//         //property: 'min-height',
//         //target: null,
//         //remove: false
//     });
// };

// 2019-12-26 :EA: unused '.room-board .matchHeights'. New design is based on Flex
//export function matchHeightsRoomBoards(timeout) {
//    //if (timeout) {
//    //    setTimeout(function () {
//    //        matchHeightsRoomBoards();
//    //    }, timeout);
//    //    return;
//    //}
//    $('.room-board .matchHeights').matchHeight({
//        byRow: true,
//        //byRow: false,
//        property: 'height',
//        //property: 'min-height',
//        //target: null,
//        //remove: false
//    });
//}

// 2022-06-03 unused function
// export function matchHeightsScheduleHead(timeout) {
//     //if (timeout) {
//     //    setTimeout(function () {
//     //        matchHeightsScheduleHead();
//     //    }, timeout);
//     //    return;
//     //}
//     $('.schedule-head-details .matchHeights').matchHeight({
//         //byRow: true,
//         byRow: false,
//         property: 'height',
//         //property: 'min-height',
//         //target: null,
//         //remove: false
//     });
//
//     $('.schedule-head .matchHeights-head').matchHeight({
//         byRow: true,
//         //byRow: false,
//         property: 'height',
//         //property: 'min-height',
//         //target: null,
//         //remove: false
//     });
// };

// 2022-06-03 unused function
// export function matchHeightsCarRental(timeout) {
//     if (timeout) {
//         setTimeout(function () {
//             matchHeightsCarRental();
//         }, timeout);
//         return;
//     }
//
//     $('.carrental-item .matchHeights').matchHeight({
//         byRow: true,
//         //byRow: false,
//         property: 'height',
//         //property: 'min-height',
//         //target: null,
//         //remove: false
//     });
// };

// 2022-06-03 unused function
// export function matchHeightsTransportModes(timeout) {
//     if (timeout) {
//         setTimeout(function () {
//             matchHeightsTransportModes();
//         }, timeout);
//         return;
//     }
//
//     $('#transport-section .transport-modes .matchHeights').matchHeight({
//         //byRow: true,
//         byRow: false,
//         property: 'height',
//         //property: 'min-height',
//         //target: null,
//         //remove: false
//     });
//
//     $('#transfer-section .transport-modes .matchHeights').matchHeight({
//         //byRow: true,
//         byRow: false,
//         property: 'height',
//         //property: 'min-height',
//         //target: null,
//         //remove: false
//     });
// };

// 21.04.2022, unused function - Igor Mazur
// export function matchHeightsTransfer(timeout) {
//     if (timeout) {
//         setTimeout(function () {
//             matchHeightsTransfer();
//         }, timeout);
//         return;
//     }
//    
//     $('.transfer-item .matchHeights').matchHeight({
//         //byRow: true,
//         byRow: false,
//         property: 'height',
//         //property: 'min-height',
//         //target: null,
//         //remove: false
//     });
// };

// 2022-06-03 unused function
// export function matchHeightsPaymentMethods() {
//     $('.payment-method-container .matchHeights').matchHeight({
//         byRow: true,
//         //byRow: false,
//         property: 'height',
//         //property: 'min-height',
//         //target: null,
//         //remove: false
//     });
// };

// 21.04.2022, unused function - Igor Mazur
// export function updateTransferImage(timeout) {
//     if (timeout) {
//         setTimeout(function () {
//             updateTransferImage();
//         }, timeout);
//         return;
//     }
//
//     var bp1 = 480;          /* Mobile landscape */
//     var bp0_max = bp1 - 1;  /* Mobile portrait */
//
//     var maxHeight = 0;
//     var heights = $(".transfer-select .transfer-item .price-container").map(function (i, item) {
//         return $(item).outerHeight(true);
//     }).toArray();
//     if (heights && heights.length > 0) {
//         maxHeight = Math.max.apply(Math,heights);
//     }
//
//     //var newWidth = $(window).width();
//     var newWidth = GetBreakpointWidth();
//
//     $(".transfer-select .transfer-item .price-container").css('margin-bottom', '');
//     $(".transfer-select .transfer-item .vehicle-img").css('margin-bottom', '');
//     $(".transfer-select .transfer-item .price-container").css('height', '');
//
//     $(".transfer-select .transfer-item").each(function () {
//         var $holder = $(this);
//         var $price = $holder.find(".price-container");
//         var $img = $holder.find(".vehicle-img");
//         if ($price.length > 0 && $img.length > 0) {
//             var margin = 0;
//             if (newWidth >= bp1) {
//                 margin = $price.outerHeight(true);
//                 margin = maxHeight;
//             }
//             $img.css('margin-bottom', margin + 'px');
//         }
//     });
//
//     $(".transfer-select .transfer-item").each(function () {
//         var $holder = $(this);
//         var $price = $holder.find(".price-container");
//         var $img = $holder.find(".vehicle-img");
//         if ($price.length > 0 && $img.length > 0) {
//             var h = '';
//             if (newWidth < bp1) {
//                 h = $img.outerHeight(true);
//                 if (h > $price.outerHeight(true))
//                     h = h + 'px';
//                 else
//                     h = $price.height() + 'px';
//             }
//             $price.css('height', h);
//         }
//     });
// };

export function ScrollToTarget(target, options) {
    if (!target || target.length == 0) return;
    if (!target.match("^#")) {
        if (!target.match("^\.")) {
            target = "." + target;
        }
        if (!target.match(":first$")) {
            target += ":first";
        }
    }

    var holder = $(target);
    if (holder && holder.length > 0) {
        var offset = $(window).height() / 2;
        if (options) {
            if (typeof options.offset === "number") {
                offset = options.offset;
            } else if (options.responsive) {
                let scrollToTop = false;
                let offset2 = 12;
                if (GetBreakpointWidth() < 480) {
                    scrollToTop = true;
                } else if (GetBreakpointWidth() < 768) {
                    scrollToTop = true;
                } else  if (GetBreakpointWidth() < 1024) {
                    scrollToTop = false;
                }

                var hasHeadRoom = typeof (global.siteHeadRoom) != "undefined" && global.siteHeadRoom && global.siteHeadRoom.initialised;

                // Give space for siteHeadRoom if it's used
                let $siteHeader = $('.site-header, nav.navbar');
                if (hasHeadRoom && $siteHeader.length > 0) {
                    let isStickedHeadRoom = $siteHeader.hasClass('headroom--pinned') 
                        || $siteHeader.hasClass('headroom--top') 
                        || $siteHeader.hasClass('slideDown')
                        ;
                    if (isStickedHeadRoom) {
                        let height = $siteHeader.outerHeight();
                        offset2 += height;
                    }
                }


                let outerHeight = holder.outerHeight();
                if (scrollToTop || outerHeight > ($(window).height() - offset2)) {
                    offset = offset2;                    
                } else {
                    offset = ($(window).height() - outerHeight) / 2;
                }
            }
        }

        $('html, body').stop().animate({
            scrollTop: holder.offset().top - offset
        }, 300);
    }
};
